module.exports = __webpack_public_path__ + "6f765e05a035f58501d93ff842bf38c3.pdf";